﻿$.fn.dxCtrlGridSondageReponse = function custom_dxCtrlGridSondageReponse(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridsondagereponse dx-ctrl");
        this.createInstance(new cdxCtrlGridSondageReponse(this, option));
    }
    return this;
}

window.cdxCtrlGridSondageReponse = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridsondagereponse"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}

    var _disableUpdateFunction = false
    var timeOutUpdate = null
    option.bddCtrl.mAddFunctionOnModifiedItemData(["sondage_reponse"], container,
        function (action, itemData) {
            if (_disableUpdateFunction) {
                _disableUpdateFunction = false
                return
            }
            window.clearTimeout(timeOutUpdate)
            timeOutUpdate = window.setTimeout(function () {
                if (typeof itemData != 'undefined') {
                    dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("sondage_reponse").id_table, itemData.id_sondage)
                } else {
                    dxGrid.mReloadData()
                }
            }, 100)
        })

    var dxGrid = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "(Aucune réponse au sondage)",
            typeData: "sondagereponse",
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            itemsToolbarSelect: mGetLstButtonToolBarSelect,
            onDisplayButtonLigne: mGetLstButtonLigne,
            onEndClickDataGrid: option.onEndClickDataGrid,
            lstTypeGrille: ["Lignes"],
            lstLstConditionBase: mGetLstLstConditionBase(),
            fields: lstField,
            allowFilter: false,
            allowCarto: false,
            allowLucene: true,
            allowCheck: true,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: true,
            hideEntete: option.hideEntete,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function mGetLstField() {

        var lst = []

        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date réponse",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            sortOrder: "desc",
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Réponse: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: false,
            visible: false
        }])

        lst = lst.concat([{
            name: "nom",
            dataField: "nom",
            caption: "Nom sondage",
            icon: "fas fa-clipboard-question",
            allowFilter: false,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string"
        }])

        lst = lst.concat([{
            name: "id_sondage",
            dataField: "id_sondage",
            caption: "Sondage",
            icon: "fas fa-clipboard-question",
            allowFilter: true,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }])


        if (!option.noGroup) {
            lst[0].groupIndex = 0
        }

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        items.push({
            location: 'after',
            visible: true,
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCheckBox({
                    value: option.bddCtrl.utiCourantParaJson[option.context_grid].check_vue,
                    text: "Vu",
                    hint: "Afficher les réponses au sondage que vous avez vu/non vu",
                    enableThreeStateBehavior: true,
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].check_vue = e.value
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        mConstruit()
                    }
                })
            }
        })

        items.push({
            location: 'after',
            visible: true,
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCheckBox({
                    value: option.bddCtrl.utiCourantParaJson[option.context_grid].check_finalise,
                    text: "Finalisé",
                    hint: "Afficher les réponses au sondage qui ont été finalisé par le répondant (ou pas)",
                    enableThreeStateBehavior: true,
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].check_finalise = e.value
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        mConstruit()
                    }
                })
            }
        })

        return items
    }

    function mGetLstButtonToolBarSelect(dxVirtualGrid) {
        var items = []
        if (typeof option.showBtTraitement == 'undefined' || option.showBtTraitement) {
            var itemToolbar = {
                location: 'before',
                visible: (dxVirtualGrid && dxVirtualGrid.toolbarSelectIsVisible),
                template: function (itemData, itemIndex, itemElement) {
                    var dxBtVueEllipsis = $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-eye",
                        colorIcone2: theme.colorBtIcon2,
                        hint: "Marquer les réponses sélectionnées comme vues",
                        opacityIcone2: "0.9",
                        onClick: function (e) {
                            var lstDataTraitement = dxVirtualGrid.mGetLstTraitementData()
                            var lstId = ""
                            lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                            option.bddCtrl.mModifValueChamp("vue", "sondage_reponse", lstId, "1", function () {
                                dxGrid.mReloadData(false)
                                mNotify(lstDataTraitement.length + " réponse" + ((lstDataTraitement.length > 1) ? "s" : "") + " de sondage marqué" + ((lstDataTraitement.length > 1) ? "s" : "") + " comme <b>vue</b>", "success", 6000)
                            })
                        }
                    }).dxCtrlButton("instance")
                    dxVirtualGrid.lstButtonForCheck.push(dxBtVueEllipsis)
                }
            }
            dxVirtualGrid.lstItemToolbarForCheck.push(itemToolbar)
            items.push(itemToolbar)

            var itemToolbar = {
                location: 'before',
                visible: (dxVirtualGrid && dxVirtualGrid.toolbarSelectIsVisible),
                template: function (itemData, itemIndex, itemElement) {
                    var dxBtVueEllipsis = $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-eye-slash",
                        colorIcone2: theme.colorBtIcon2,
                        hint: "Marquer les réponses sélectionnées comme non vues",
                        opacityIcone2: "0.9",
                        onClick: function (e) {
                            var lstDataTraitement = dxVirtualGrid.mGetLstTraitementData()
                            var lstId = ""
                            lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                            option.bddCtrl.mModifValueChamp("vue", "sondage_reponse", lstId, "0", function () {
                                dxGrid.mReloadData(false)
                                mNotify(lstDataTraitement.length + " réponse" + ((lstDataTraitement.length > 1) ? "s" : "") + " de sondage marqué" + ((lstDataTraitement.length > 1) ? "s" : "") + " comme <b>non vue</b>", "success", 6000)
                            })
                        }
                    }).dxCtrlButton("instance")
                    dxVirtualGrid.lstButtonForCheck.push(dxBtVueEllipsis)
                }
            }
            dxVirtualGrid.lstItemToolbarForCheck.push(itemToolbar)
            items.push(itemToolbar)

        }
        return items
    }

    var lstLstConditionBaseSource = (option.lstLstConditionBase ? option.lstLstConditionBase : [[]])
    function mGetLstLstConditionBase() {
        var lstLstConditionBase = JSON.parse(JSON.stringify(lstLstConditionBaseSource))
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].check_finalise != 'undefined' &&
            option.bddCtrl.utiCourantParaJson[option.context_grid].check_finalise != null) {
            lstLstConditionBase.forEach(function (lst) {
                lst.push({ nom_champ: "finalise", ope: "=", valeur: [{ value: (option.bddCtrl.utiCourantParaJson[option.context_grid].check_finalise ? "1" : "0") }] })
            })
        }
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].check_vue != 'undefined' &&
            option.bddCtrl.utiCourantParaJson[option.context_grid].check_vue != null) {
            lstLstConditionBase.forEach(function (lst) {
                lst.push({ nom_champ: "vue", ope: "=", valeur: [{ value: (option.bddCtrl.utiCourantParaJson[option.context_grid].check_vue ? "1" : "0") }] })
            })
        }
        return lstLstConditionBase
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []
        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                icon: "fas fa-trash-alt",
                elementAttr: { class: "dx-button-grille-ligne" },
                focusStateEnabled: false,
                text: "Corbeille",
                hint: "Mettre à la corbeille",
                onClick(e) {
                    e.event.stopPropagation();
                    dxGrid.mRemoveRow(dataGrid)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    _disableUpdateFunction = true
                    obj.mDelData(function () { })
                }
            },
        })
        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                elementAttr: { class: "dx-button-grille-ligne" },
                icon: ((dataTemplate.vue == "1") ? "fas fa-eye-slash" : "fas fa-eye"),
                focusStateEnabled: false,
                text: ((dataTemplate.vue == "0") ? "Marquer comme 'vue'" : "Marquer comme 'non vue'"),
                hint: ((dataTemplate.vue == "0") ? "Marquer comme 'vue'" : "Marquer comme 'non vue'"),
                onClick(e) {
                    if (typeof e != "undefined") e.event.stopPropagation();
                    var newNouveau = ((dataTemplate.vue == 0) ? 1 : 0)
                    dataTemplate.vue = newNouveau
                    dxGrid.mRepaintRow(dataGrid, false)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    obj.data.vue = newNouveau
                    _disableUpdateFunction = true
                    obj.mSaveChamp("vue", function () { })
                    mNotify("Réponse marquée comme " + (newNouveau == "1" ? "VUE" : "NON VUE"), "success", 5000)
                }
            },
        })
        toolbar.option("items", items)
    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}